import { BCMSDate, BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, StateManager, useBCMSContext, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import AddCardWrapper from "components/shared/containers/AddCardWrapper";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UITextInput from "components/ui/UITextInput";
import Classes, { Card } from "model";
import React from "react";
import "./styles.css";

/**
 * @function AddCardVerificationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for AddCardVerificationPage
 */

export default function AddCardVerificationPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const defaultData = getDefaultData(context);
  const { goStep, state } = useWorkflow() ?? {};
  const navigate = useRoute();
  const data = { ...getDefaultData(context), ...state, ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: (obj, prop) => val => {
      const crud = BCMSStateManagerCRUD.init(state);
      if(obj && prop) {
        crud.update([ "data", obj, prop ], val);
      } else {
        crud.update([ "data", prop ], val);
      }
      
      crud.submit(setState);
    },

    cancel: () => {
      navigate(`/home/recenttransactions/`);
    },

    next: () => {
      const split = data.card.expDatePlaceholder.split("/");

      if(split.length === 2) {
        const month = !isNaN(split[0]) ? split[0] : new Date().getMonth();
        const year = !isNaN(split[1]) ? "20" + split[1] : new Date().getFullYear();
        const date = new Date();
  
        date.setMonth(month);
        date.setFullYear(year);
  
        data.card.expDate = date;
      }
      else {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 2);
  
        data.card.expDate = date;
      }

      goStep(3, { data, ui });
    },
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = controller => {
  const branding = controller.state.branding;
  const options = controller.state.branding.options;
  const card = options.include_debit_chw23 === "false"
      ? BCMSDefaultModel.creditCard()
      : BCMSDefaultModel.debitCard();
  card.number = "";
  card.expDatePlaceholder = "";
  card.id = Card.nextID();

  if(options.activate_card_chw23 === "false") {
      card.active = true;
  }

  return { 
    card,
    branding,
    code: "",
    street: "",
    zip: "",
  };
}

export const getDefaultUI = () => {

}

function PageContent(props) {
  const { data, update, cancel, next } = useStateManager();
  const { card } = data;
  const expDate = card.expDatePlaceholder instanceof BCMSDate ? card.expDatePlaceholder.format() : card.expDatePlaceholder;
  //const workflowStep = useWorkflowStep(getDefaultCard, getWorkflowSteps);

  //const [ state, setState ] = useState({ zip: "", street: "" });
  //const updateState = prop => value => setState({ ...state, [ prop ] : value });
  
  //const card = workflowStep.read("card");
  //const expDate = workflowStep.read("expDate");

  //const updateCode = value => workflowStep.update([ "card", "securityCode" ], value);
  //const updateExp = value => workflowStep.update([ "expDate" ], value);

  /*const nextButton = evt => {
    card.securityCode = card.securityCode === undefined || card.securityCode.length < 3 ? "123" : card.securityCode;

    const split = expDate.split("/");

    if(split.length === 2) {
      const month = !isNaN(split[0]) ? split[0] : new Date().getMonth();
      const year = !isNaN(split[1]) ? "20" + split[1] : new Date().getFullYear();
      const date = new Date();

      date.setMonth(month);
      date.setFullYear(year);

      card.expDate = date;
    }
    else {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 2);

      card.expDate = date;
    }

    workflowStep.workflow.nextStep(workflowStep.getStepState);
  };*/
  //const cancelButton = evt => workflowStep.navigate("/");

  return (
    <AddCardWrapper className="add-card-verification-page">
      <MainContentContainer className="hide-chevron-icon" header={<MainContentHeader text={
          <><div className="flex-container flex-vertical text-center all-center-container">
          <h1>Card Verification</h1>
          <p className="sub-text card-number">{ card.maskedNumber }</p>
        </div></> } />}>
        <FormContainer>
          <FormRow>
            <p>Please enter your address, card security code and expiration date.</p>
          </FormRow>
          <FormRow>
            <UITextInput placeholder="Security Code (CVC2/CVV2)*" type="password" value={ card.securityCode } onChange={ update("card", "securityCode") } dataPoint="Card_Verification_Security_Code" />
            <p className="sub-text">3 Digit Code at the back of your card</p>
          </FormRow>
          <FormRow>
            <UITextInput value={ data.street } onChange={ update(undefined, "street") } placeholder="Street Address*" dataPoint="Card_Verification_Street" />
          </FormRow>
          <FormRow>
            <UITextInput value={ data.zip } onChange={ update(undefined, "zip") } placeholder="Zip code*" dataPoint="Card_Verification_Zip" />
          </FormRow>
          <FormRow>
            <UITextInput placeholder="Expiration Date (MM/YY)*" value={ expDate } onChange={ update("card", "expDatePlaceholder") } dataPoint="Card_Verification_Expiration" />
          </FormRow>

          <FormButtonContainer>
            <UIPrimaryButton text="Next" onClick={ next } dataPoint="Card_Verification_Next" />
            <UICancelButton text="Cancel" onClick={ cancel } />
          </FormButtonContainer>
        </FormContainer>
      </MainContentContainer>
    </AddCardWrapper>
  );
}